// Affiliate program IDs for each vendor. Keep secrets-ish values here so
// per-provider code doesn't sprinkle raw IDs throughout the app.
export const AFFILIATE_CONFIG = {
    tcgplayer: {
        // Impact.com publisher account id for commandersalt.
        affiliateId: '7310831',
        // Campaign id Impact provisioned for this site/program pairing.
        campaignId: '1780961',
        // TCGPlayer's program id on Impact — same value for every publisher.
        programId: '21018',
    },
};
